import { render, staticRenderFns } from "./nATest.vue?vue&type=template&id=16db5cd4&"
import script from "./nATest.vue?vue&type=script&lang=js&"
export * from "./nATest.vue?vue&type=script&lang=js&"
import style0 from "./nATest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports